/* import __COLOCATED_TEMPLATE__ from './select-method.hbs'; */
import Component from '@ember/component';

const CLASS_NAME = 'SH-c-payout-add-method-select-method';

export default Component.extend({
  classNames: [CLASS_NAME, 'LSG-l-grid', 'justify-center'],
  CLASS_NAME,

  /** @param {Function} */
  onDismiss: () => {},

  /** @param {Function} */
  onSelect: () => {},

  /** @param {Boolean} */
  isLoading: false,

  /** @param {Boolean} */
  isSubmitting: false,

  actions: {
    handleDismiss() {
      this.get('onDismiss')();
    },

    handleSelect() {
      this.get('onSelect')();
    },
  },
});
